import React, { FC } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import debounce from 'lodash-es/debounce'
import { Option } from 'monapt'
import { compose, lifecycle, withHandlers, withState } from 'recompose'

type Props = RouteComponentProps<{}>

type State = {
  scrollPositions: any
  setScrollPositions: (positions: any) => void
}

type Handlers = {
  onScroll: (e: UIEvent) => void
}

const enhance = compose<Props, {}>(
  withRouter,

  withState<Props, State | null, 'scrollPositions', 'setScrollPositions'>(
    'scrollPositions',
    'setScrollPositions',
    null,
  ),

  withHandlers<any, any>({
    onScroll:
      ({
        location,
        setScrollPositions,
        scrollPositions,
      }: RouteComponentProps<{}> & State) =>
      () => {
        setScrollPositions({
          ...scrollPositions,
          [location.pathname]: document.scrollingElement?.scrollTop,
        })
      },
  }),

  lifecycle<Props & Handlers & State, any>({
    componentDidMount() {
      window.addEventListener(
        'scroll',
        debounce(this.props.onScroll as any, 150),
      )
    },

    componentDidUpdate(prevProps) {
      const shouldRestoreScrollPosition = Option(this.props.location.state)
        .flatMap(({ restoreScrollPosition }) => Option(restoreScrollPosition))
        .getOrElse(() => false)

      const scrollDestination = Option(this.props.scrollPositions)
        .flatMap((positions) => Option(positions[this.props.location.pathname]))
        .getOrElse(() => 0)

      if (this.props.location.pathname !== prevProps.location.pathname) {
        window.scrollTo(0, shouldRestoreScrollPosition ? scrollDestination : 0)
      }
    },
  }),
)

const RestoreScrollPosition: FC = (props) => <>{props.children}</>

export default enhance(RestoreScrollPosition)
